import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { localize } from "@/lib/localize";

export default function BoardOfDirectors() {
  const { t, i18n } = useTranslation();
  const [members, setMembers] = useState([]);

  useEffect(() => {
    api.get("/board-members").then((r) => setMembers(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pb-24">
      <section className="border-b border-ink/10 py-20" aria-labelledby="board-title">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="tag mb-4">{t("board.eyebrow")}</div>
          <h1 id="board-title" className="font-display font-black text-ink text-5xl sm:text-6xl leading-[1]">
            {t("board.title_a")} <span className="text-teal">{t("board.title_b")}</span>.
          </h1>
          <p className="mt-6 text-ink/70 max-w-2xl leading-relaxed">{t("board.intro")}</p>
        </div>
      </section>

      <section className="mt-16" aria-label={t("nav.board")}>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10">
          {members.map((raw) => {
            const m = localize(raw, i18n.language, ["title", "affiliation"]);
            return (
            <article
              key={m.id}
              data-testid={`board-member-${m.id}`}
              className="bg-base p-8 card-hover border-transparent border-2"
            >
              <div className="aspect-square overflow-hidden mb-5 bg-surface border-l-2 border-teal">
                {m.photo_url && (
                  <img
                    src={m.photo_url}
                    alt={`Portrait of ${m.name}`}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              <div className="font-mono text-[10px] tracking-widest text-teal uppercase mb-2">
                {m.title}
              </div>
              <h2 className="font-display font-bold text-ink text-xl leading-tight">{m.name}</h2>
              <p className="mt-2 text-ink/60 text-sm leading-relaxed">{m.affiliation}</p>
            </article>
          );})}
        </div>
      </section>
    </div>
  );
}
